import React from 'react'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import { EmptyArray } from 'lib/array/arrayUtils'
import { hasDifferentPackagesForRooms } from 'selectors/offerPage/multipleRoomBookingSelectors'
import styled from 'styled-components'
import { rem } from 'polished'
import SoftOfferPageWalledGarden from 'components/Common/SoftOfferPageWalledGarden'
import FlashHotelAvailabilityButton from '../FlashHotel/FlashHotelMobileVariant/FlashHotelAvailabilityButton'
import OfferPageStickyFooter from '../OfferPageStickyFooter'
import { isAvailableForPurchase } from 'selectors/offerPage/offerPageSelectors'
import { isMultipleRoomBookingActive } from 'selectors/offerPage/offerPageSharedSelectors'
import { hasSelectedRooms } from 'lib/offer/offerPageUtil'
import { isRoomsInvalid } from 'lib/search/searchUtils'

const StyledOfferPageStickyFooter = styled(OfferPageStickyFooter)`
  padding: ${rem(12)} ${rem(20)};
`
interface Props {
  offer: App.Offer
  rooms?: Array<App.RoomOccupants>
  checkInDate?: string
  hasMultiRoomDifferentPackages?: boolean
  availableForPurchase?: boolean
}

function AccommodationOfferPageStickyFooter(props: Props) {
  const {
    rooms = EmptyArray,
    checkInDate,
    offer,
    hasMultiRoomDifferentPackages,
    availableForPurchase,
  } = props

  const canBook = !!(checkInDate && rooms && availableForPurchase)
  const canBookNowMultiRoom = rooms.length > 1 && canBook && hasMultiRoomDifferentPackages
  const invalidRoomSelection = !hasSelectedRooms(rooms) || isRoomsInvalid(rooms)
  const canViewOptions = !!checkInDate && !invalidRoomSelection

  if (canBookNowMultiRoom || canViewOptions) {
    return null
  }

  return (
    <StyledOfferPageStickyFooter
      visible
      callToActionDisabled
      offer={offer}
    >
      <SoftOfferPageWalledGarden>
        <FlashHotelAvailabilityButton size="large" fit="full-width" />
      </SoftOfferPageWalledGarden>
    </StyledOfferPageStickyFooter>
  )
}

export default withOfferPageAndReduxState((state, appState) => ({
  hasMultiRoomDifferentPackages: isMultipleRoomBookingActive(state, appState) && hasDifferentPackagesForRooms(state, appState),
  offer: state.offer,
  rooms: state.rooms,
  checkInDate: state.checkInDate,
  availableForPurchase: isAvailableForPurchase(state, appState),
}), AccommodationOfferPageStickyFooter)
